import { ActionIcon, Badge, Box, Button, Grid, Group, Modal, Paper, Select, Skeleton, Stack, Table, Text, TextInput, ThemeIcon, Title } from "@mantine/core";
import { IconClock, IconEye, IconSearch, IconUserCheck, IconUserOff, IconUsers } from "@tabler/icons-react";
import { message } from "antd";
import dayjs from "dayjs";

import { useState, useEffect } from "react";
import { useAuthContext } from "../../Hooks/UseAuthContext";

const UsersManagement = () => {

    // =========================================
    // STATES
    // =========================================
    const { user } = useAuthContext();
    const [statusFilter, setStatusFilter] = useState("");
    const [search, setSearch] = useState("");
    const [dashboardLoading, setDashboardLoading] = useState(true);
    const [usersloading, setusersloading] = useState(true);
    const [dashboardData, setDashboardData] = useState(null);
    const [users, setusers] = useState([]);
    const [selectedUser, setSelectedUswer] = useState(null);
    const [userModal, setUserModal] = useState(false);
    const [userStatus, setUserStatus] = useState("");
    const [updateloading, setUpdateLoading] = useState(false);

    // =========================================
    // STATUS COLOR
    // =========================================

    const getStatusColor = (status) => {

        switch (status) {

            case "Active":
                return "green";

            case "Inactive":
                return "red";

            default:
                return "yellow";
        }
    };

    // =========================================
    // FILTER USERS
    // =========================================

    const filteredUsers = users.filter((user) => {

        const matchesStatus =
            statusFilter
                ? user.Account_Status === statusFilter
                : true;

        const matchesSearch =
            user.Company_Name
                .toLowerCase()
                .includes(search.toLowerCase()) ||

            user.Authorized_Person_Name
                .toLowerCase()
                .includes(search.toLowerCase()) ||

            user.Company_Email
                .toLowerCase()
                .includes(search.toLowerCase());

        return (
            matchesStatus &&
            matchesSearch
        );
    });

    const getAllusers = async () => {

        try {

            setusersloading(true);
            const response = await fetch("https://api.boompay.in/admin/get-all-merchants",
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${user}`,
                    }
                }
            );

            const data = await response.json();
            if (response.status === 200) {
                setusers(data.users);
            } else {
                message.error(data.message);
            }

        } catch (error) {
            console.log(error);
            message.error("Failed to fetch dashboard data");

        } finally {
            setusersloading(false);
        }
    };

    const handelUpdateUserStatus = async () => {
        if (!selectedUser || !userStatus) {
            message.error("Please select a user and status to update.");
            return;
        }
        try {

            setUpdateLoading(true)
            const response = await fetch("https://api.boompay.in/admin/update-user-login-status",
                {
                    method: "PUT",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${user}`,
                    },
                    body: JSON.stringify({
                        userId: selectedUser._id,
                        newStatus: userStatus
                    })
                }
            );

            const data = await response.json();

            if (response.status === 200) {
                message.success(data?.message);
                setUserModal(false);
                setUserStatus("");
                setSelectedUswer(null);
                getAllusers();
            } else {
                message.error(data.message);
            }
        } catch (error) {
            console.log(error);
            message.error(error?.message);

        } finally {
            setUpdateLoading(false);
        }
    }

    useEffect(() => {

        // ==========================================
        // FRONTEND API FUNCTION
        // ==========================================

        const getDashboardCounts = async () => {

            try {
                //setDashboardLoading(true);
                const response = await fetch("https://api.boompay.in/admin/dashboard-counts",
                    {
                        method: "GET",
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${user}`,
                        }
                    }
                );

                const data = await response.json();

                if (response.status === 200) {
                    setDashboardData(data.dashboard);
                } else {
                    message.error(data.message);
                }
            } catch (error) {
                console.log(error);
                message.error("Failed to fetch dashboard data");
            } finally {
                setDashboardLoading(false);
            }
        };

        const getAllusers = async () => {

            try {
                //setDashboardLoading(true);
                const response = await fetch("https://api.boompay.in/admin/get-all-merchants",
                    {
                        method: "GET",
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${user}`,
                        }
                    }
                );

                const data = await response.json();

                if (response.status === 200) {
                    setusers(data.users);
                } else {
                    message.error(data.message);
                }

            } catch (error) {
                console.log(error);
                message.error("Failed to fetch dashboard data");
            } finally {
                setusersloading(false);
            }
        };
        if (user) {
            getDashboardCounts();
            getAllusers();
        }

    }, [user])

    return (
        <>
            <Box p="md">

                {/* ========================================= */}
                {/* HEADER */}
                {/* ========================================= */}

                <Group
                    justify="space-between"
                    mb="lg"
                >

                    <div>

                        <Title order={2}>
                            Users Management
                        </Title>

                        <Text c="dimmed">
                            Manage registered users and account approval
                        </Text>

                    </div>

                </Group>

                {/* ========================================= */}
                {/* TOP CARDS */}
                {/* ========================================= */}

                <Grid mb="lg">

                    {[
                        {
                            title: "Total Users",
                            value: dashboardData?.users?.total_users || "0",
                            color: "blue",
                            icon: <IconUsers size={22} />,
                        },

                        {
                            title: "Pending Users",
                            value: dashboardData?.users?.pending_users || "0",
                            color: "yellow",
                            icon: <IconClock size={22} />,
                        },

                        {
                            title: "Active Users",
                            value: dashboardData?.users?.active_users || "0",
                            color: "green",
                            icon: <IconUserCheck size={22} />,
                        },

                        {
                            title: "Inactive Users",
                            value: dashboardData?.users?.inactive_users || "0",
                            color: "red",
                            icon: <IconUserOff size={22} />,
                        },

                    ].map((card, index) => (

                        <Grid.Col
                            key={index}
                            span={{
                                base: 12,
                                sm: 6,
                                md: 3
                            }}
                        >
                            <Skeleton visible={dashboardLoading} h="100%">
                                <Paper
                                    withBorder
                                    radius="xl"
                                    p="xl"
                                    h="100%"
                                >

                                    <Group
                                        justify="space-between"
                                    >

                                        <Stack gap={2}>

                                            <Text
                                                size="sm"
                                                c="dimmed"
                                            >
                                                {card.title}
                                            </Text>

                                            <Title order={2}>
                                                {card.value}
                                            </Title>

                                        </Stack>

                                        <ThemeIcon
                                            size={50}
                                            radius="xl"
                                            color={card.color}
                                            variant="light"
                                        >
                                            {card.icon}
                                        </ThemeIcon>

                                    </Group>

                                </Paper>
                            </Skeleton>


                        </Grid.Col>

                    ))}

                </Grid>

                {/* ========================================= */}
                {/* FILTERS */}
                {/* ========================================= */}

                <Paper
                    withBorder
                    radius="xl"
                    p="md"
                    mb="lg"
                >

                    <Group grow>

                        <TextInput
                            placeholder="Search by company, user or email"
                            leftSection={
                                <IconSearch size={16} />
                            }
                            value={search}
                            onChange={(e) =>
                                setSearch(
                                    e.target.value
                                )
                            }
                        />

                        <Select
                            placeholder="Filter by status"
                            data={[
                                "Pending",
                                "Active",
                                "Inactive",
                            ]}
                            value={statusFilter}
                            onChange={setStatusFilter}
                            clearable
                        />

                    </Group>

                </Paper>

                {/* ========================================= */}
                {/* USERS TABLE */}
                {/* ========================================= */}

                <Paper
                    withBorder
                    radius="xl"
                    p="md"

                >

                    <Group
                        justify="space-between"
                        mb="md"
                    >

                        <Title order={4}>
                            Registered Users
                        </Title>

                        {/* <Button>
                        Export Users
                    </Button> */}

                    </Group>

                    <Skeleton visible={usersloading} h="100%">
                        <Table
                            striped
                            highlightOnHover
                            withTableBorder
                            withColumnBorders
                            loading={usersloading}
                        >

                            <Table.Thead>
                                <Table.Tr>
                                    <Table.Th>
                                        S.No
                                    </Table.Th>

                                    <Table.Th>
                                        Company Name
                                    </Table.Th>

                                    <Table.Th>
                                        User Name
                                    </Table.Th>

                                    <Table.Th>
                                        Email
                                    </Table.Th>

                                    <Table.Th>
                                        Mobile
                                    </Table.Th>

                                    {/* <Table.Th>
                                PAN
                            </Table.Th> */}

                                    <Table.Th>
                                        Signup Date
                                    </Table.Th>

                                    <Table.Th>
                                        Status
                                    </Table.Th>

                                    <Table.Th>
                                        Action
                                    </Table.Th>

                                </Table.Tr>

                            </Table.Thead>

                            <Table.Tbody>

                                {filteredUsers.length > 0 ? (

                                    filteredUsers.map(
                                        (user, index) => (

                                            <Table.Tr
                                                key={index}
                                            >

                                                <Table.Td>
                                                    {index + 1}
                                                </Table.Td>

                                                <Table.Td>
                                                    {user.Company_Name}
                                                </Table.Td>

                                                <Table.Td>
                                                    {user.Authorized_Person_Name}
                                                </Table.Td>

                                                <Table.Td>
                                                    {user.Company_Email}
                                                </Table.Td>

                                                <Table.Td>
                                                    {user.Authorized_Person_Mobile_Number}
                                                </Table.Td>

                                                <Table.Td>
                                                    {user.updatedAt}
                                                </Table.Td>

                                                <Table.Td>

                                                    <Badge
                                                        color={
                                                            getStatusColor(
                                                                user.Account_Status
                                                            )
                                                        }
                                                    >
                                                        {user.Account_Status}
                                                    </Badge>

                                                </Table.Td>

                                                <Table.Td>

                                                    <Group gap="xs">

                                                        {/* VIEW */}

                                                        <ActionIcon
                                                            variant="light"
                                                        >
                                                            <IconEye
                                                                size={18}
                                                                onClick={() => {
                                                                    setSelectedUswer(user);
                                                                    setUserModal(true);
                                                                }}
                                                            />
                                                        </ActionIcon>

                                                        {/* ACTION MENU */}

                                                        {/* <Menu
                                                    shadow="md"
                                                    width={180}
                                                >

                                                    <Menu.Target>

                                                        <ActionIcon
                                                            variant="light"
                                                        >
                                                            <IconDotsVertical
                                                                size={18}
                                                            />
                                                        </ActionIcon>

                                                    </Menu.Target>

                                                    <Menu.Dropdown>

                                                        <Menu.Item
                                                            color="green"
                                                            leftSection={
                                                                <IconCheck
                                                                    size={16}
                                                                />
                                                            }
                                                        >
                                                            Activate
                                                            Account
                                                        </Menu.Item>

                                                        <Menu.Item
                                                            color="red"
                                                            leftSection={
                                                                <IconX
                                                                    size={16}
                                                                />
                                                            }
                                                        >
                                                            Deactivate
                                                            Account
                                                        </Menu.Item>

                                                    </Menu.Dropdown>

                                                </Menu> */}

                                                    </Group>

                                                </Table.Td>

                                            </Table.Tr>

                                        )
                                    )

                                ) : (

                                    <Table.Tr>

                                        <Table.Td
                                            colSpan={9}
                                            ta="center"
                                        >

                                            No users found

                                        </Table.Td>

                                    </Table.Tr>

                                )}

                            </Table.Tbody>

                        </Table>
                    </Skeleton>

                </Paper>

            </Box>

            <Modal
                opened={userModal}
                onClose={() => setUserModal(false)}
                title="User Details"
                size="lg"
            >
                {selectedUser && (
                    <Stack spacing="md">
                        <Text><strong>Company Name:</strong> {selectedUser.Company_Name}</Text>
                        <Text><strong>User Name:</strong> {selectedUser.Authorized_Person_Name}</Text>
                        <Text><strong>Email:</strong> {selectedUser.Company_Email}</Text>
                        <Text><strong>Mobile:</strong> {selectedUser.Authorized_Person_Mobile_Number}</Text>
                        <Text><strong>Status:</strong> {selectedUser.Account_Status}</Text>
                        <Text><strong>Signup Date:</strong> {dayjs(selectedUser.updatedAt).format(
                            "DD MMM YYYY hh:mm A"
                        )}</Text>

                        <Select
                            label="Change Account Status"
                            data={['Active', 'Inactive']}
                            placeholder="Action"
                            value={userStatus}
                            onChange={setUserStatus}
                        />

                        <Button onClick={handelUpdateUserStatus} loading={updateloading}>Update {userStatus} Status</Button>
                    </Stack>

                )}

            </Modal>
        </>
    );
};

export default UsersManagement;